module.exports = __webpack_public_path__ + "static/better-business-bureau-complaints-2016-6-2e4f9e0399ebf9cda67482bccc80f8cc.png";